var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelefone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#002C43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8025 19.9237C22.3095 19.5936 21.8165 19.1745 21.3242 18.8412C20.6671 18.3422 20.2561 18.5917 19.517 19.2577L18.449 20.3402C18.0387 20.6702 17.956 20.6702 17.5457 20.4233C13.3563 18.092 12.0421 15.0954 11.7138 14.096C11.6318 13.6802 11.6318 13.6802 11.878 13.5132C13.3563 12.3482 12.7819 11.1826 12.7819 11.1826L11.96 9.01824C11.6344 8.10209 11.0567 7.68625 10.1535 8.26908C8.42834 9.35091 7.60713 11.0994 8.18217 13.1805C9.90666 18.593 13.848 22.4213 19.1881 23.8365C20.5844 24.1665 21.4883 24.086 22.5557 22.754L23.2955 21.8385C24.1167 20.8385 23.2955 20.3395 22.8025 19.9237Z",
    fill: "#FBFBFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/Telefone.274684051d23fe3a4db17e9aa48e4e5f.svg";
export { ForwardRef as ReactComponent };